import React, { useEffect, useState } from "react";
// import "../styles/Header.css";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, Button, Drawer, Image } from "antd";
import {
  BellOutlined,
  CustomerServiceOutlined,
  FileSearchOutlined,
  HeartOutlined,
  MenuOutlined,
  PoweroffOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import logo from "../assets/logo.png";
import Vector from "../assets/Vector.png";
import cart from "../assets/cart.png";
import profile from "../assets/profile.png";
import arabic from "../assets/arabic.png";
import us from "../assets/us.png";
import { useDispatch, useSelector } from "react-redux";
import { fetchUser } from "../redux/getUserSlice";
import { fetchAllNotification } from "../redux/allNotificationSlice";
import { logoutUser } from "../redux/authSlice";
import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Space } from "antd";
import "antd/dist/reset.css";

const { SubMenu } = Menu;

const Navbar = () => {
  const { t, i18n } = useTranslation();

  const { language } = i18n;
  const [unreadCount, setUnreadCount] = useState(0);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isAuthenticated } = useSelector((state) => state.auth || {});

  console.log(isAuthenticated);
  const { getUser, status, error } = useSelector((state) => state.getUser);

  useEffect(() => {
    dispatch(fetchUser());
  }, [dispatch]);

  const { allNotification } = useSelector((state) => state.allNotification);

  useEffect(() => {
    dispatch(fetchAllNotification());
  }, [dispatch]);

  useEffect(() => {
    if (allNotification?.data?.length > 0) {
      const unread = allNotification.data.filter(
        (not) => not.viewed == 0
      ).length;
      setUnreadCount(unread);
    }
  }, [allNotification]);

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate("/signin");
  };

  const items = [
    {
      label:
        getUser?.image == null ? (
          <img src={profile} className="w-[40px]" />
        ) : (
          <img
            src={`https://service.samoolah.com/${getUser?.image}`}
            className="w-[38px] mt-0 rounded-full"
          />
        ),
      key: "SubMenu",
      children: [
        {
          type: "group",
          label: (
            <div className="flex items-center my-4 lg:px-5">
              <div>
                {getUser?.image == null ? (
                  <img src={profile} className="w-[50px]" />
                ) : (
                  <img
                    src={`https://service.samoolah.com/${getUser?.image}`}
                    className="w-[50px] rounded-full"
                    onError={(e) => (e.target.src = profile)}
                  />
                )}
              </div>
              <div
                className={`${language == "en" ? "ml-4" : "mr-4"
                  } font-semibold`}
              >
                <p className="text-[#14294F] text-xl">
                  {" "}
                  {t("Hi")} {getUser?.name}!
                </p>
                <Link to="/myprofile" className="text-[#FE6625] underline">
                  {t("Visit_Personal_Profile")}
                </Link>
              </div>
            </div>
          ),
        },
        {
          type: "group",
          label: (
            <div className="mb-4 lg:px-5">
              {/* <Link to="/favorites" className="flex items-center">
                <div className="bg-[#FCFBFA] text-[#EAA182] px-2 py-1 rounded-lg text-2xl">
                  <HeartOutlined />
                </div>
                <p
                  className={`text-[#424E66] text-lg ${
                    language == "en" ? "ml-3" : "mr-3"
                  } font-semibold`}
                >
                  {t("My_Favourites")}
                </p>
              </Link> */}
              <Link to="/allpreviewrequests" className="flex items-center">
                <div className="bg-[#FCFBFA] text-[#EAA182] px-2 py-1 rounded-lg text-2xl">
                  <FileSearchOutlined />
                </div>
                <p
                  className={`text-[#424E66] text-lg ${language == "en" ? "ml-3" : "mr-3"
                    } font-semibold`}
                >
                  {t("Preview_Requests")}
                </p>
              </Link>
              <Link to="/" className="flex items-center mt-3">
                <div className="bg-[#FCFBFA] text-[#EAA182] px-2 py-1 rounded-lg text-2xl">
                  <CustomerServiceOutlined />
                </div>
                <p
                  className={`text-[#424E66] text-lg ${language == "en" ? "ml-3" : "mr-3"
                    } font-semibold`}
                >
                  {t("Support_FAQ")}
                </p>
              </Link>
              <Link to="/" className="flex items-center mt-3">
                <div className="bg-[#FCFBFA] text-[#EAA182] px-2 py-1 rounded-lg text-2xl">
                  <WalletOutlined />
                </div>
                <p
                  className={`text-[#424E66] text-lg ${language == "en" ? "ml-3" : "mr-3"
                    } font-semibold`}
                >
                  {t("My_Wallet")}
                </p>
              </Link>
              <Link
                to="/notifications"
                className="flex items-center mt-3 relative"
              >
                <div className="bg-[#FCFBFA] text-[#EAA182] px-2 py-1 rounded-lg text-2xl">
                  <BellOutlined />
                  {unreadCount > 0 && (
                    <span
                      className={`absolute -top-1 ${language == "en" ? "-left-3" : "-right-3"
                        } bg-red-500 text-white text-xs rounded-full px-2 py-1`}
                    >
                      {unreadCount}
                    </span>
                  )}
                </div>
                <p
                  className={`text-[#424E66] text-lg ${language == "en" ? "ml-3" : "mr-3"
                    } font-semibold`}
                >
                  {t("Notifications")}
                </p>
              </Link>
            </div>
          ),
        },
        {
          type: "group",
          label: (
            <div
              className={`${language == "en" && "lg:pl-5"
                } flex items-center justify-between mb-4 lg:pr-2`}
            >
              <div className="flex items-center">
                {language == "en" ? (
                  <>
                    <img src={arabic} className="w-[50px] max-lg:w-[35px]" />
                    <button
                      onClick={() => changeLanguage("ar")}
                      className="text-[#424E66] lg:text-lg ml-3 font-semibold"
                    >
                      العربية
                    </button>
                  </>
                ) : (
                  <>
                    <img src={us} className="w-[50px] max-lg:w-[35px]" />
                    <button
                      onClick={() => changeLanguage("en")}
                      className="text-[#424E66] lg:text-lg mr-3 font-semibold"
                    >
                      English
                    </button>
                  </>
                )}
              </div>
              <div className="">
                <button
                  onClick={handleLogout}
                  className="bg-[#FE9B71] lg:text-lg text-white px-5 max-lg:px-2 py-2 rounded-full flex items-center"
                >
                  <PoweroffOutlined />
                  <p className={language == "en" ? "ml-3" : "mr-3"}>
                    {t("Sign_Out")}
                  </p>
                </button>
              </div>
            </div>
          ),
        },
      ],
    },
  ];

  const menuItems = [
    {
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://service.samoolah.com/"
        >
          {t("Services login")}
        </a>
      ),
      key: "0",
    },
    // {
    //   label: (
    //     <a
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       href="https://ecommerce.samoolah.com/"
    //     >
    //       {t("Ecommerce login")}
    //     </a>
    //   ),
    //   key: "1",
    // },
  ];

  const Links = [
    { name: "Services", name_ar: "الخدمات", link: "/services" },
    // { name: "Products", name_ar: "تخفيضات", link: "/products" },
    {
      name: "Preview requests",
      name_ar: "طلبات المعاينة",
      link: "/previewrequests",
    },
    isAuthenticated
      ? { name: "My Orders", name_ar: "طلباتي", link: "/myorders" }
      : null,
    {
      type: "dropdown",
      component: (
        <Dropdown
          menu={{
            items: menuItems,
          }}
          className="lg:mx-5"
        >
          <a
            onClick={(e) => e.preventDefault()}
            className={({ isActive }) =>
              isActive
                ? "hover:#F16622 active:#F16622 duration-500 text-[#F16622] text-center"
                : "hover:#F16622 active:#F16622 duration-500 text-[#FE9B71]"
            }
          >
            <Space className="text-[#FE9B71]">{t("My Dashboard")}</Space>
          </a>
        </Dropdown>
      ),
    },
  ].filter(Boolean);

  const [open, setVisible] = useState(false);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const [current, setCurrent] = useState("mail");

  const onClick = (e) => {
    console.log("click ", e);
    setCurrent(e.key);
  };

  useEffect(() => {
    if (i18n.language === "ar") {
      document.body.setAttribute("dir", "rtl");
    } else {
      document.body.setAttribute("dir", "ltr");
    }
  }, [i18n.language]);

  return (
    <div>
      <div className="bg-white nav flex items-center justify-between bg-white py-4 px-20 max-lg:px-5 max-lg:hidden lg:flex navbar">
        <div className="flex items-center relative z-10">
          <Link to="/">
            <Image width={80} src={logo} preview={false} />
          </Link>
          <div>
            <ul
              dir={language == "ar" && "rtl"}
              className={`flex items-center md:static md:z-auto z-[-1] left-0 md:w-auto md:pl-0 pl-9 transition-all duration-500 ease-in mx-3`}
            >
              {Links.map((link, index) =>
                link.type === "dropdown" ? (
                  <li
                    key={index}
                    style={{ display: "inline-block", margin: "0 10px" }}
                    className={`${language == "en" ? "ml-8" : "mr-8"
                      } text-lg my-0 max-lg:my-7 font-[ Cinzel Decorative] relative z-20`}
                  >
                    {link.component}
                  </li>
                ) : (
                  <li
                    key={link.name}
                    className={`${language == "en" ? "ml-8" : "mr-8"
                      } text-lg my-0 max-lg:my-7 font-[ Cinzel Decorative] relative z-20`}
                  >
                    <NavLink
                      to={link.link}
                      className={({ isActive }) =>
                        isActive
                          ? "hover:#F16622 active:#F16622 duration-500 text-[#F16622] text-center"
                          : "hover:#F16622 active:#F16622 duration-500 text-[#FE9B71]"
                      }
                    >
                      {({ isActive }) => (
                        <div>
                          <p className="font-medium text-lg">
                            {language == "en" ? link.name : link.name_ar}
                          </p>
                          {isActive && (
                            <img
                              src={Vector}
                              className={`${link.link == "/previewrequests"
                                ? "w-[130px] h-[7px]"
                                : "w-[75px]"
                                } ${link.link == "/myorders" &&
                                isAuthenticated == false &&
                                "hidden"
                                } mx-auto`}
                            />
                          )}
                        </div>
                      )}
                    </NavLink>
                  </li>
                )
              )}
              <li>
                {isAuthenticated ? (
                  ""
                ) : (
                  <div className="flex items-center">
                    {language == "en" ? (
                      <>
                        <img
                          src={arabic}
                          className="w-[35px] max-lg:w-[35px]"
                        />
                        <button
                          onClick={() => changeLanguage("ar")}
                          className="text-[#FE9B71] lg:text-lg ml-3 font-semibold"
                        >
                          العربية
                        </button>
                      </>
                    ) : (
                      <>
                        <img src={us} className="w-[35px] max-lg:w-[35px]" />
                        <button
                          onClick={() => changeLanguage("en")}
                          className="text-[#FE9B71] lg:text-lg mr-3"
                        >
                          English
                        </button>
                      </>
                    )}
                  </div>
                )}
              </li>
            </ul>
          </div>
        </div>
        <div className="flex items-center relative z-10">
          {/* <Link to="/cart">
            <Image width={35} src={cart} preview={false} />
          </Link> */}

          {isAuthenticated === true ? (
            <>
              <Menu
                onClick={onClick}
                selectedKeys={[current]}
                mode="horizontal"
                items={items}
              />
            </>
          ) : (
            <>
              <Link
                to="/signin"
                className={`bg-[#FE9B71] text-white rounded-3xl w-[140px] h-[37px] flex items-center justify-center mx-3 font-semibold`}
              >
                {t("Sign_In")}
              </Link>
              <Link
                to="/signupotp"
                className="text-[#FE9B71] rounded-3xl border-2 border-[#FE9B71] w-[140px] h-[37px] flex items-center justify-center font-semibold max-lg:mx-3 max-lg:mt-4"
              >
                {t("Sign_Up")}
              </Link>
            </>
          )}
        </div>
      </div>

      <div className="bg-white nav flex items-center justify-between py-4 max-lg:px-5 lg:hidden max-lg:flex ">
        <Link to="/">
          <Image
            width={80}
            src={logo}
            preview={false}
            className="relative z-10"
          />
        </Link>

        <div className="flex items-center relative z-10">
          {isAuthenticated === true && (
            <>
              <Menu
                onClick={onClick}
                selectedKeys={[current]}
                mode="horizontal"
                items={items}
              />
            </>
          )}

          {/* <Image width={35} src={cart} preview={false} /> */}

          <Button
            type="primary"
            className={`bg-[#FE9B71] ${language == "en" ? "ml-0" : "mr-0"}`}
            onClick={showDrawer}
          >
            <MenuOutlined />
          </Button>
          <Drawer title="" placement="right" onClose={onClose} visible={open}>
            <Menu
              // mode="inline"
              className="border-e-0"
              dir={language == "ar" && "rtl"}
            >
              {Links.map((link, index) =>
                link.type === "dropdown" ? (
                  <li
                    key={index}
                    style={{ display: "inline-block", margin: "0 0px" }}
                    className={`${language == "en" ? "" : ""
                      } text-lg font-semibold my-0 max-lg:my-7 font-[ Cinzel Decorative] relative z-20`}
                  >
                    {link.component}
                  </li>
                ) : (
                  <NavLink
                    to={link.link}
                    key={link.name}
                    className={({ isActive }) =>
                      isActive
                        ? "hover:#AD834E active:#AD834E duration-500 text-lg block mb-7 font-[ Cinzel Decorative] text-[#F16622]"
                        : "hover:#AD834E active:#AD834E duration-500 text-lg block mb-7 font-[ Cinzel Decorative] text-[#FE9B71]"
                    }
                  >
                    {/* {language == "en" ? link.name : link.name_ar} */}
                    <div>
                      <p className="font-medium text-lg">
                        {language == "en" ? link.name : link.name_ar}
                      </p>
                      {({ isActive }) =>
                        isActive && (
                          <Image width={80} src={Vector} preview={false} />
                        )
                      }
                    </div>
                  </NavLink>
                )
              )}
              <div className="mt-5">
                {isAuthenticated ? (
                  ""
                ) : (
                  <div className="flex items-center">
                    {language == "en" ? (
                      <>
                        <img
                          src={arabic}
                          className="w-[35px] max-lg:w-[35px]"
                        />
                        <button
                          // onClick={() => changeLanguage("ar")}
                          onClick={() => {
                            changeLanguage("ar");
                            setVisible(false);
                          }}
                          className="text-[#FE9B71] text-lg ml-3 font-semibold"
                        >
                          العربية
                        </button>
                      </>
                    ) : (
                      <>
                        <img src={us} className="w-[35px] max-lg:w-[35px]" />
                        <button
                          onClick={() => {
                            changeLanguage("en");
                            setVisible(false);
                          }}
                          className="text-[#FE9B71] text-lg mr-3 font-semibold"
                        >
                          English
                        </button>
                      </>
                    )}
                  </div>
                )}
              </div>
              <div className="relative z-10 mt-5">
                {isAuthenticated === true ? (
                  <>
                    {/* <Menu
                      onClick={onClick}
                      selectedKeys={[current]}
                      mode="horizontal"
                      items={items}
                    /> */}
                  </>
                ) : (
                  <>
                    <Link
                      to="/signin"
                      className={`bg-[#FE9B71] text-white rounded-3xl w-[140px] h-[37px] flex items-center justify-center ${language == "en" ? "lg:ml-7" : "lg:mr-7"
                        } font-semibold`}
                    >
                      {t("Sign_In")}
                    </Link>
                    <Link
                      to="/signupotp"
                      className="max-lg:my-3 text-[#FE9B71] rounded-3xl border-2 border-[#FE9B71] w-[140px] h-[37px] flex items-center justify-center font-semibold"
                    >
                      {t("Sign_Up")}
                    </Link>
                  </>
                )}
              </div>
              {/* <Image width={35} src={cart} preview={false} /> */}
            </Menu>
          </Drawer>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
